<p-confirmDialog key="transferconfirm1" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="transferconfirm2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Message-->
<div>
	<label>You are about to transfer {{ intTransferCount }} {{ strWork }} to CAASS.</label>
</div>

<!--Options-->
<div class="TopMargin SquareBorder">
	<!--Transfer Type-->
	<h4 class="CenterText">Select Transfer Options:</h4>

	<div class="Grid2Col TopMargin">
		<input
			[disabled]="IsLoading() == true"
			id="TransferOnly"
			type="radio"
			class="CHK"
			name="TransferOption"
			[(ngModel)]="TransferOption"
			value="TransferOnly"
		/>
		<label for="TransferOnly">Don't Add to Queue</label>

		<input [disabled]="IsLoading() == true" id="AddToQ" type="radio" class="CHK" name="TransferOption" [(ngModel)]="TransferOption" value="AddToQ" />
		<label for="AddToQ">Add to Queue</label>

		<!-- <input
			[disabled]="IsLoading() == true"
			id="SkipToPrint"
			type="radio"
			class="CHK"
			name="TransferOption"
			[(ngModel)]="TransferOption"
			value="SkipToPrint"
		/>
		<label for="SkipToPrint">Add to Queue and Print Cards</label> -->
	</div>
</div>

<!--Queue Options-->
<div *ngIf="TransferOption == 'AddToQ' || TransferOption == 'SkipToPrint'" class="TopMargin SquareBorder">
	<h4 class="CenterText">Queue Options:</h4>

	<div
		[ngClass]="{
			QGrid1Col: ShowBoth() == false,
			QGrid3Col: ShowBoth() == true
		}"
	>
		<div class="QItem" *ngIf="HasStudent == true">
			<h4>Student</h4>

			<div class="QSubGrid">
				<label>Printer:</label>
				<select
					[disabled]="IsLoading() == true"
					class="form-control"
					name="Student_IDPrinterID"
					[(ngModel)]="Student_IDPrinterID"
					[style.color]="Student_IDPrinterID > 0 ? 'Black' : 'Red'"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstPrinter" [ngValue]="o.IDPrinterID" [style.color]="o.IDPrinterID > 0 ? 'Black' : 'Red'">
						{{ o.PrinterName }}
					</option>
				</select>

				<label>Card:</label>
				<select
					[disabled]="IsLoading() == true"
					class="form-control"
					name="Student_IDCardTemplateID"
					[(ngModel)]="Student_IDCardTemplateID"
					[style.color]="Student_IDCardTemplateID == '' ? 'Red' : 'Black'"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstStudentTemplates" [ngValue]="o.IDCardTemplateID" [style.color]="o.IDCardTemplateID == '' ? 'Red' : 'Black'">
						{{ o.CardName }}
					</option>
				</select>
			</div>
		</div>

		<div class="GridSpacer" *ngIf="ShowBoth() == true"></div>

		<div class="QItem" *ngIf="HasStaff == true">
			<h4>Staff</h4>

			<div class="QSubGrid">
				<label>Printer:</label>
				<select
					[disabled]="IsLoading() == true"
					class="form-control"
					name="Staff_IDPrinterID"
					[(ngModel)]="Staff_IDPrinterID"
					[style.color]="Staff_IDPrinterID > 0 ? 'Black' : 'Red'"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstPrinter" [ngValue]="o.IDPrinterID" [style.color]="o.IDPrinterID > 0 ? 'Black' : 'Red'">
						{{ o.PrinterName }}
					</option>
				</select>

				<label>Card:</label>
				<select
					[disabled]="IsLoading() == true"
					class="form-control"
					name="Staff_IDCardTemplateID"
					[(ngModel)]="Staff_IDCardTemplateID"
					[style.color]="Staff_IDCardTemplateID == '' ? 'Red' : 'Black'"
				>
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstStaffTemplates" [ngValue]="o.IDCardTemplateID" [style.color]="o.IDCardTemplateID == '' ? 'Red' : 'Black'">
						{{ o.CardName }}
					</option>
				</select>
			</div>
		</div>
	</div>
</div>

<!--Printing Options-->
<div *ngIf="TransferOption == 'SkipToPrint'" class="TopMargin SquareBorder">
	<h4 class="CenterText">Printing Options:</h4>
	<div
		[ngClass]="{
			QGrid1Col: ShowBoth() == false,
			QGrid3Col: ShowBoth() == true
		}"
	>
		<div class="QItem" *ngIf="HasStudent == true">
			<h4>Student</h4>

			<div class="QSubGrid">
				<label>Sort By:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Student_SortID" [(ngModel)]="Student_SortID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstStudentSortBy" [ngValue]="o.ID">
						{{ o.Desc }}
					</option>
				</select>
			</div>

			<label class="TopMargin">Only Print Students In:</label>
			<div class="QSubGrid">
				<label>Academy:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Student_AcademyID" [(ngModel)]="Student_AcademyID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstAcademy" [ngValue]="o.AcademyID">
						{{ o.AcademyDesc }}
					</option>
				</select>

				<label>Grade:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Student_GradeLevelID" [(ngModel)]="Student_GradeLevelID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstGradeLevel" [ngValue]="o.GradeLevelID">
						{{ o.GradeLevelDesc }}
					</option>
				</select>

				<label>Homeroom:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Student_HomeroomID" [(ngModel)]="Student_HomeroomID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstHomeroom" [ngValue]="o.HomeroomID">
						{{ o.HomeroomDesc }}
					</option>
				</select>
			</div>
		</div>

		<div class="GridSpacer" *ngIf="ShowBoth() == true"></div>

		<div class="QItem" *ngIf="HasStaff == true">
			<h4>Staff</h4>

			<div class="QSubGrid">
				<label>Sort By:</label>
				<select [disabled]="IsLoading() == true" class="form-control" name="Staff_SortID" [(ngModel)]="Staff_SortID">
					<option value="" style="display: none"></option>
					<option *ngFor="let o of lstStaffSortBy" [ngValue]="o.ID">
						{{ o.Desc }}
					</option>
				</select>
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onTransfer()">Transfer</button>
	<button [disabled]="Processing == true" class="btn btn-warning LeftMargin" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
